import { ReactElement } from "react";
import styles from "./styles.module.css";

type Props = {
  titulo: string;
  modalidade: string;
  area: string;
  inicio: Date;
  fim: Date;
  situacao: string;
  children: ReactElement | ReactElement[];
};
const selecionaCor = (situacao: string) => {
  switch (situacao) {
    case "Aceito":
      return styles.aprovado;
    case "Pendente":
      return styles.pendente;
    case "Rejeitado":
      return styles.rejeitado;
  }
};
const RowPlanoDeTrabalho = ({
  titulo,
  modalidade,
  area,
  inicio,
  fim,
  situacao,
  children,
}: Props) => {
  return (
    <tr className={styles.row}>
      <td>{titulo}</td>
      <td className={styles.sexto}>{modalidade}</td>
      <td className={styles.sexto}>{area}</td>
      <td className={styles.sexto}>
        <strong>inicio:</strong> {inicio.toLocaleDateString()} <br />
        <strong>fim:</strong> {fim.toLocaleDateString()}
      </td>
      <td className={selecionaCor(situacao)}>{situacao}</td>
      <td className={styles.btncoll}>{children}</td>
    </tr>
  );
};
export default RowPlanoDeTrabalho;
